import { render, staticRenderFns } from "./cwkp.vue?vue&type=template&id=488f6d62&"
import script from "./cwkp.vue?vue&type=script&lang=js&"
export * from "./cwkp.vue?vue&type=script&lang=js&"
import style0 from "./cwkp.vue?vue&type=style&index=0&id=488f6d62&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports